module.exports = __webpack_public_path__ + "static/AvenirLTProHeavyOblique-18e68e2063f35201b8be10b952723d37.woff";